// This file is AUTOGENERATED, do not edit it manually!!!

export const common = {
    activity: 'Activity',
    add_check_list_item_placeholder: 'Add checklist item or use Ctrl+V to paste a list of items',
    add_checklist_label: 'Add checklist',
    add_more: 'Add more',
    add_reaction_title: 'Add reaction',
    ai: 'AI',
    ai_analyzing: 'Analyzing patterns',
    ai_building: 'Building forecasting model',
    ai_description: 'The {brandName} AI forecast is using machine learning algorithms to find patterns and relationships between events and actions by processing your account’s historical data. As a result, it will show the most likely project end date and its confidence in this prediction.',
    ai_forecast: 'AI forecast',
    ai_forecast_date: 'AI forecasted project end date',
    ai_how_works: 'Learn more about how AI works',
    ai_not_enough_data: 'Not enough historical data to make a reliable forecast. Using the system actively will ensure more accurate forecasts. <a href={0} target=\'_blank\' class={1}>Learn more</a> about AI forecast.',
    ai_planned_date: 'Planned project end date',
    ai_result: 'AI forecast results',
    ai_reviewing: 'Reviewing historical data',
    apply: 'Apply',
    available: 'Available',
    back: 'Back',
    CanChangeWorkflowForProjectOutdatedData: 'Workflow is already applied for the project. Please refresh the page to actualize data.',
    CanDeleteCategoryHasTask: 'It\'s impossible to delete category which is used in activities.',
    CanDeletePriorityHasProject: 'It\'s impossible to delete priority which is used in projects.',
    CanDeletePriorityHasTask: 'It\'s impossible to delete priority which is used in activities.',
    CanDeletePriorityIsInternal: 'It\'s impossible to delete internal system priority.',
    CanDeleteStatusIsWorkflowTypeStatus: 'It\'s impossible to delete default status.',
    CanDeleteStatusUsed: 'It\'s impossible to delete status which is used in any entity.',
    CanDeleteThresholdIsInternal: 'It\'s impossible to delete internal system threshold.',
    CanDeleteVacationTypeDefault: 'It\'s impossible to delete default vacation type.',
    CanDeleteVacationTypeHasVacation: 'It\'s impossible to delete vacation type that has vacation assigned.',
    CanDeleteWorkflowIsSingle: 'There should be at least one workflow in the system.',
    CanDeleteWorkflowIsUsed: 'It\'s impossible to delete workflow which is used in projects.',
    CanDisableStatusIsUsed: 'It\'s impossible to disable status which is used in entity',
    CanDisableStatusIsWorkflowTypeStatus: 'It\'s impossible to disable default status',
    CanEdit_Task_AccessDenied: 'You have no permissions to edit this activity',
    CanEditValueThresholdIsInternal: 'The preset system threshold values cannot be altered.',
    CanSetWorkflowTypeStatusIsWorkflowTypeStatus: 'It\'s impossible to mark status as default for already default status.',
    change: 'change',
    ChangeProjectProgressError: 'The progress of a project with tasks cannot be edited.',
    ChangeTaskProgressError: 'The progress of a parent task cannot be edited.',
    check_all_label: 'Check all',
    checklist_name: 'Checklist',
    column_group_custom_fields: 'Custom fields',
    column_group_custom_fields_user: 'User custom fields',
    columns: 'Columns',
    Completed_Projects: 'Completed projects',
    Completed_Tasks: 'Completed activities',
    Copy_Text: 'Copy',
    copyPostfix: 'Copy',
    create: 'Create',
    created_by: 'Created by',
    creation_date: 'Creation date',
    current_plan: 'Current plan: <b>{0}</b>',
    dates: 'Dates',
    delete_checklist_label: 'Delete checklist',
    description_title: 'Description',
    edit_check_list_item_placeholder: 'Edit checklist item',
    Edit_Text: 'Edit',
    emoji: 'Emoji',
    empty_list: 'No results have been found to match the search query/filter applied',
    error_reload: '{brandName} version has been updated. For the correct operation of the application, you need to reload the page.',
    export: 'Export',
    export_csv: 'Export to CSV',
    export_pdf: 'Export to PDF',
    filters: 'Filters',
    freeze: 'Freeze column',
    from: 'From',
    general: 'General',
    global_search: 'Search',
    global_search_text: 'Search messages, files and more',
    GotIt: 'Got it',
    group_by: 'Group by',
    group_by_template: 'Group by: {0}',
    here: 'here',
    hourly_rate_unit: '/hr',
    icons: 'Icons',
    in: 'in',
    in_use: 'In use',
    items_text: '1#{0} item#{0} items',
    job_role: 'Job role',
    label_custom_date_range: 'Custom date range',
    label_daily: 'Daily',
    label_monthly: 'Monthly',
    label_weekly: 'Weekly',
    label_yearly: 'Yearly',
    least_likely: 'Least Likely',
    month: 'Month',
    MoreActions: 'More actions',
    most_likely: 'Most Likely',
    move_down: 'Move down',
    move_up: 'Move up',
    name_title: 'Name',
    next_month: 'Next month',
    next_week: 'Next week',
    no: 'No',
    no_available_filters: 'No available values for filter',
    no_data_to_display: 'No data to display',
    no_data_to_display_for_widget: 'No data to display. Filters, including both widget-specific and general filters, may be preventing the display of data.',
    NoPermissionToArchiveProject: 'Requested action (archive project) is not available for the following reason: You don\'t have permissions to archive project.',
    not_calculated: 'Not calculated',
    not_in_use: 'Not in use',
    pause: 'Pause',
    PortfolioLimitError: 'You have reached the limit of 60 portfolios in Team Edition. Please upgrade to {brandName} Enterprise Edition.',
    previous_month: 'Previous month',
    previous_week: 'Previous week',
    previous_year: 'Previous year',
    qb_disconnect_denied: 'You does not have QuickBooks token associated with this account',
    quarter: 'Quarter',
    quick_search_placeholder: 'Search by ID or name',
    quick_search_placeholder_for_archive: 'Search archived projects by name or ID',
    RateLimitExceededByAccount: 'We apologize for the inconvenience, but due to high traffic we are currently limiting the number of requests you can make. Please try again later.',
    RateLimitExceededByUser: 'We apologize for the inconvenience, but due to high traffic we are currently limiting the number of requests you can make. Please try again later.',
    read_more: 'Learn more',
    RecordConversionToActivityDifferentWorkflows: 'It\'s impossible to convert record, since different Workflows have been applied to the project and template.',
    records: 'Records',
    remove_checklist_item_label: 'Remove checklist item',
    request_resources: 'Request resources',
    reset_timer_title: 'Reset timer',
    resource_type_label: 'Resource type',
    resume: 'Resume',
    role: 'Role',
    schedule_hours: 'Schedule hours',
    security_group: 'Access level',
    select: 'Select',
    share: 'Share',
    short_quarter0: 'Q1',
    short_quarter1: 'Q2',
    short_quarter2: 'Q3',
    short_quarter3: 'Q4',
    show: 'Show',
    show_template: 'Show: {0}',
    skillsDeleteConfirm: 'The skill will be removed from other users’ profiles and job roles, where it is being used',
    SnapshotsLimitError: 'You have reached the limit of 3 project snapshots. Please upgrade to {brandName} Enterprise Edition.',
    sort: 'Sort',
    sort_activities: 'Sort activities by:',
    sort_ascending: 'Sort ascending',
    sort_az: 'Sort A→Z',
    sort_descending: 'Sort descending',
    sort_projects: 'Sort projects by:',
    sort_resources: 'Sort resources by:',
    sort_za: 'Sort Z→A',
    start: 'Start',
    start_analyze: 'Start Analysis',
    start_new_project: 'Start new project',
    stop_timer_title: 'Stop timer',
    sub_features_list_title: 'This feature includes:',
    SystemTaskCreatorName: 'System',
    Task_CanAccessBillingInformation_AccessDenied: 'You have no permissions to edit this activity billing settings',
    this_month: 'This month',
    this_week: 'This week',
    this_year: 'This year',
    ThresholdValueDuplicate: 'This threshold value has already been added.',
    TimeoutErrorMessage: 'Your request has timed out. Please try again later.',
    to: 'To',
    today: 'Today',
    uncheck_all_label: 'Uncheck all',
    unfreeze: 'Unfreeze column',
    UnknownErrorMessage: 'Sorry, something went wrong... Please refresh the page.',
    update_date: 'Update date',
    updated_by: 'Updated by',
    upgrade: 'Upgrade',
    upgrade_to_enterprise: 'Upgrade to Enterprise',
    usage: 'Usage',
    week: 'Week',
    WindowUnload_UnsavedChanges: 'There are unsaved changes. Are you sure you would like to leave this page?',
    year: 'Year',
    yes: 'Yes',
    yesterday: 'Yesterday',
};
